/* hit ctrl+K then M, then type react, it enables react intillicence*/    /* OR we could've renamed the file to .jsx*/
/* rafce */ 

import React from 'react';

const Home = () => {
  return(                                 /*This thing is the HTML part*/
      <div className="home-container">
      </div>
  );  
};

export default Home;


/*
import { FiArrowRight } from "react-icons/fi";


const Home = () => {
  return(                                 
      <div className="home-container">
          <div className="">         
            <div className="">   
                       
            </div>
            <div className='home-text-section'>
              <h1 className='primary-heading'>
                Book an appointment with
                lifestyle medicine experts
              </h1>
              <p className='primary-text'>
                Healthy switchefr chefs do all the prep work, like peeding,
                chopping
                & marianting, so you can cook a fresh food.
              </p>
              <button className='secondary-button'>
                Order Now<FiArrowRight />
              </button>
            </div>
            <div className="home-image-section">    

            </div>
          </div>
      </div>
  );  
};

export default Home;
*/